<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom card-stretch gutter-b" id="page">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">
              Détail du service
            </h3>
            <div class="card-toolbar">
              <b-dropdown
                size="sm"
                variant="link"
                toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                no-caret
                right
                no-flip
              >
                <template v-slot:button-content>
                  <i class="ki ki-bold-more-ver"></i>
                </template>
                <!--begin::Navigation-->
                <div class="navi navi-hover" style="width: 250px">
                  <b-dropdown-text
                    tag="div"
                    class="navi-item"
                    @click="startEdit()"
                  >
                    <a href="javascript:;" class="navi-link">
                      <span class="navi-icon">
                        <i class="fas fa-edit"></i>
                      </span>
                      <span class="navi-text">Modifier</span>
                    </a>
                  </b-dropdown-text>

                  <b-dropdown-text
                    tag="div"
                    class="navi-item"
                    v-b-modal.add-sub-service-modal
                  >
                    <a href="javascript:;" class="navi-link">
                      <span class="navi-icon">
                        <i class="fas fa-plus"></i>
                      </span>
                      <span class="navi-text">Ajouter un pack</span>
                    </a>
                  </b-dropdown-text>
                </div>
                <!--end::Navigation-->
              </b-dropdown>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-xl-6">
                <div class="d-flex flex-wrap align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Service:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span
                        class="text-dark-75 font-weight-bolder font-size-h6"
                        >{{ service.name }}</span
                      >
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
                <div class="separator separator-dashed mt-2 mb-2"></div>
                <div class="d-flex flex-row align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Description:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span class="font-weight-bolder font-size-sm">{{
                        service.description
                      }}</span>
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
              </div>
              <div class="col-xl-6">
                <div class="d-flex flex-wrap align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Visible ?:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span
                        v-if="service.isActive"
                        class="text-success font-weight-bolder font-size-h6"
                      >
                        Oui</span
                      >
                      <span
                        v-if="!service.isActive"
                        class="text-danger font-weight-bolder font-size-h6"
                      >
                        Non</span
                      >
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
                <div class="separator separator-dashed mt-2 mb-2"></div>
                <div class="d-flex flex-row align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Image:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <a
                        target="_blank"
                        v-bind:href="service.image"
                        class="font-weight-bolder font-size-sm"
                        >{{ service.image }}</a
                      >
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
              </div>
            </div>

            <br />
            <h5 class="card-title font-weight-bolder text-dark">
              Packs
            </h5>
            <table class="table table-head-custom table-vertical-center">
              <thead>
                <tr class="text-uppercase">
                  <th class="pl-0" style="min-width: 100px">ordre</th>
                  <th class="pl-0" style="min-width: 100px">Pack</th>
                  <th style="min-width: 120px">Prix</th>
                  <th>Visible ?</th>
                  <th>Accepte le code parrainage ?</th>
                  <th class="pr-0 text-right" style="min-width: 160px">
                    action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="subService in service.subServices"
                  :key="subService.guid"
                >
                  <td class="pl-0">
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    >
                      {{ subService.order }}
                    </span>
                  </td>
                  <td class="pl-0">
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    >
                      {{ subService.name }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    >
                      {{
                        Intl.NumberFormat("fr", {
                          style: "currency",
                          currency: "CAD",
                        }).format(subService.amount)
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="subService.isActive"
                      class="text-success font-weight-bolder font-size-h6"
                    >
                      Oui</span
                    >
                    <span
                      v-if="!subService.isActive"
                      class="text-danger font-weight-bolder font-size-h6"
                    >
                      Non</span
                    >
                  </td>
                  <td>
                    <span
                      v-if="subService.acceptReferralCode"
                      class="text-success font-weight-bolder font-size-h6"
                    >
                      Oui</span
                    >
                    <span
                      v-if="!subService.acceptReferralCode"
                      class="text-danger font-weight-bolder font-size-h6"
                    >
                      Non</span
                    >
                  </td>
                  <td class="pr-0 text-right">
                    <button
                      class="btn btn-icon btn-light btn-hover-primary btn-sm"
                      @click="startEditSubService(subService)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--end::Body-->
       
        </div>
      </div>
    </div>

    <b-modal
      id="edit-service-modal"
      ref="edit-service-modal"
      title="Modifier le service"
      size="lg"
      centered
    >
      <div class="row">
        <div class="form-group col-6">
          <label>Nom (fr) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="editService.fr.name"
            :class="{ 'is-invalid': $v.editService.fr.name.$error }"
          />
          <div v-if="$v.editService.fr.name.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>

        <div class="form-group col-6">
          <label>Nom (en) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="editService.en.name"
            :class="{ 'is-invalid': $v.editService.en.name.$error }"
          />
          <div v-if="$v.editService.en.name.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6">
          <label>Description (fr) <span class="text-danger">*</span></label>
          <textarea
            class="form-control"
            rows="3"
            v-model="editService.fr.description"
            :class="{ 'is-invalid': $v.editService.fr.description.$error }"
          ></textarea>
          <div
            v-if="$v.editService.fr.description.$invalid"
            class="invalid-feedback"
          >
            Champ obligatoire
          </div>
        </div>

        <div class="form-group col-6">
          <label>Description (en) <span class="text-danger">*</span></label>
          <textarea
            class="form-control"
            rows="3"
            v-model="editService.en.description"
            :class="{ 'is-invalid': $v.editService.en.description.$error }"
          ></textarea>
          <div
            v-if="$v.editService.en.description.$invalid"
            class="invalid-feedback"
          >
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group ">
        <label>Image (url) <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          v-model="editService.image"
          :class="{ 'is-invalid': $v.editService.image.$error }"
        />
        <div v-if="$v.editService.image.$invalid" class="invalid-feedback">
          Champ obligatoire
        </div>
      </div>

      <div class="form-group ">
        <label>Ordre</label>
        <input
          type="nubmer"
          class="form-control"
          v-model="editService.order"       
        />     
      </div>

      <div class="form-group row">
        <label class="col-3 col-form-label">Visible ?</label>
        <div class="col-3">
          <span class="switch switch-outline switch-icon switch-success">
            <label>
              <input
                type="checkbox"
                name="select"
                v-model="editService.isActive"
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-overlay :show="isLoading" rounded="sm">
          <button
            type="button"
            class="btn btn-success"
            @click="updateService()"
          >
            Valider
          </button>
        </b-overlay>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('edit-service-modal')"
        >
          Fermer
        </button>
      </template>
    </b-modal>

    <b-modal
      id="add-sub-service-modal"
      ref="add-sub-service-modal"
      title="Ajouter un pack"
      size="lg"
      centered
    >
      <div class="row">
        <div class="form-group col-6">
          <label>Nom (fr) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="subService.fr.name"
            :class="{ 'is-invalid': $v.subService.fr.name.$error }"
          />
          <div v-if="$v.subService.fr.name.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>

        <div class="form-group col-6">
          <label>Nom (en) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="subService.en.name"
            :class="{ 'is-invalid': $v.subService.en.name.$error }"
          />
          <div v-if="$v.subService.en.name.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group ">
        <label>Prix <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          v-model="subService.amount"
          :class="{ 'is-invalid': $v.subService.amount.$error }"
        />
        <div v-if="$v.subService.amount.$invalid" class="invalid-feedback">
          Champ obligatoire
        </div>
      </div>

      <div class="form-group row">
        <label class="col-3 col-form-label">Visible ?</label>
        <div class="col-3">
          <span class="switch switch-outline switch-icon switch-success">
            <label>
              <input
                type="checkbox"
                name="select"
                v-model="subService.isActive"
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-overlay :show="isLoading" rounded="sm">
          <button
            type="button"
            class="btn btn-success"
            @click="addSubService()"
          >
            Valider
          </button>
        </b-overlay>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('add-sub-service-modal')"
        >
          Fermer
        </button>
      </template>
    </b-modal>

    <b-modal
      id="edit-sub-service-modal"
      ref="edit-sub-service-modal"
      title="Modifier le pack"
      size="lg"
      centered
    >
      <div class="row">
        <div class="form-group col-6">
          <label>Nom (fr) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="editSubService.fr.name"
            :class="{ 'is-invalid': $v.editSubService.fr.name.$error }"
          />
          <div
            v-if="$v.editSubService.fr.name.$invalid"
            class="invalid-feedback"
          >
            Champ obligatoire
          </div>
        </div>

        <div class="form-group col-6">
          <label>Nom (en) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="editSubService.en.name"
            :class="{ 'is-invalid': $v.editSubService.en.name.$error }"
          />
          <div
            v-if="$v.editSubService.en.name.$invalid"
            class="invalid-feedback"
          >
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group ">
        <label>Prix <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          v-model="editSubService.amount"
          :class="{ 'is-invalid': $v.editSubService.amount.$error }"
        />
        <div v-if="$v.editSubService.amount.$invalid" class="invalid-feedback">
          Champ obligatoire
        </div>
      </div>
      
      <div class="form-group ">
        <label>Ordre</label>
        <input
          type="nubmer"
          class="form-control"
          v-model="editSubService.order"       
        />     
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label">Accepte le code parrainage ?</label>
        <div class="col-3">
          <span class="switch switch-outline switch-icon switch-success">
            <label>
              <input
                type="checkbox"
                name="select"
                v-model="editSubService.acceptReferralCode"
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label">Visible ?</label>
        <div class="col-3">
          <span class="switch switch-outline switch-icon switch-success">
            <label>
              <input
                type="checkbox"
                name="select"
                v-model="editSubService.isActive"
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-overlay :show="isLoading" rounded="sm">
          <button
            type="button"
            class="btn btn-success"
            @click="updateSubService()"
          >
            Valider
          </button>
        </b-overlay>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('edit-sub-service-modal')"
        >
          Fermer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.image {
  max-height: 300px;
  max-width: 300px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SELECT_NOTIFICATION } from "../../../core/services/store/notification.module";

import servicesService from "../../../services/services.service";

//import SearchApiService from "../../../core/services/searchapi.service";
//import JwtService from "../../../core/services/jwt.service";
import SweetAlert2 from "../../../helpers/sweetAlert2.helper";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "detail",
  components: {},
  data() {
    return {
      isLoading: false,
      service: { subServices: [] },
      editService: { fr: {}, en: {} },
      subService: { fr: {}, en: {} },
      editSubService: { fr: {}, en: {} },
    };
  },
  validations: {
    editService: {
      fr: {
        name: {
          required,
        },
        description: {
          required,
        },
      },
      en: {
        name: {
          required,
        },
        description: {
          required,
        },
      },
      image: {
        required,
      },
    },
    subService: {
      fr: {
        name: {
          required,
        },
      },
      en: {
        name: {
          required,
        },
      },
      amount: {
        required,
      },
    },
    editSubService: {
      fr: {
        name: {
          required,
        },
      },
      en: {
        name: {
          required,
        },
      },
      amount: {
        required,
      },
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getService(to.params.guid);
    next();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Prestataires" },
      { title: "Detail" },
    ]);
    this.$store.dispatch(SELECT_NOTIFICATION, this.$route.params.guid);

    this.getService(this.$route.params.guid);
  },
  methods: {
    getService: function(guid) {
      servicesService.getService(guid).then((result) => {
        this.service = result.data;
      });
    },

    startEdit: function() {
      this.editService = { ...this.service };
      this.$bvModal.show("edit-service-modal");
    },
    updateService() {
      this.$v.editService.$touch();
      if (this.$v.editService.$anyError) {
        return;
      }

      SweetAlert2.question(
        "Confirmation",
        "Voulez-vouz modifier le service ?"
      ).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          servicesService
            .editService(this.editService)
            .then(() => {
              this.isLoading = false;
              SweetAlert2.success("L'opération a réussi", "");
              this.getService(this.$route.params.guid);
              this.$bvModal.hide("edit-service-modal");
            })
            .catch(() => {
              this.isLoading = false;
              SweetAlert2.error("Une erreur s'est produite", "");
            });
        }
      });
    },

    addSubService() {
      this.$v.subService.$touch();
      if (this.$v.subService.$anyError) {
        return;
      }

      this.subService.serviceGuid = this.service.guid;
      SweetAlert2.question(
        "Confirmation",
        "Voulez-vouz ajouter ce pack ?"
      ).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          servicesService
            .addSubService(this.subService)
            .then(() => {
              this.isLoading = false;
              SweetAlert2.success("L'opération a réussi", "");
              this.getService(this.$route.params.guid);
              this.$bvModal.hide("add-sub-service-modal");
            })
            .catch(() => {
              this.isLoading = false;
              SweetAlert2.error("Une erreur s'est produite", "");
            });
        }
      });
    },

    startEditSubService: function(subService) {
      this.editSubService = { ...subService };
      this.$bvModal.show("edit-sub-service-modal");
    },

    updateSubService() {
      this.$v.editSubService.$touch();
      if (this.$v.editSubService.$anyError) {
        return;
      }

      SweetAlert2.question(
        "Confirmation",
        "Voulez-vouz modifier le pack ?"
      ).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          servicesService
            .editSubService(this.editSubService)
            .then(() => {
              this.isLoading = false;
              SweetAlert2.success("L'opération a réussi", "");
              this.getService(this.$route.params.guid);
              this.$bvModal.hide("edit-sub-service-modal");
            })
            .catch(() => {
              this.isLoading = false;
              SweetAlert2.error("Une erreur s'est produite", "");
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
